define([
        'jQuery',
        'library/fcse-widget/widget',
        'library/fcse-compatibility/object',
        'library/fcse-xslider/jquery.xslider',
        'clientComponents/jquery-touchpunch/jquery.touchpunch'
    ],
    function($, Widget, Object) {

        var SliderFilterWidget = function(selector, options) {
            Widget.call(this, selector, $.extend({
                handleClass: 'selector'
            }, options));

            this._init();

        };

        SliderFilterWidget.prototype = $.extend(Object.create(Widget.prototype), {

            _init: function() {
                var $control = $(this.element);

                var self = this;
                var slider = $control.find('.slider');

                if (!slider.length) return;

                var steps = $.parseJSON($control.attr('data-steps'));
                var snaps = _.map(steps, function(step) {
                    return step.value;
                });

                this._nullValue = parseInt($control.data('null-value'));
                this._nullValueText = $control.data('null-value-text');
                this._valueTemplate = $control.data('value-template');
                this._valuePostfix = $control.data('value-postfix');
                this._label = $control.find('[data-fcse-role="slider-label"]');

                this._internalNullValue = null;

                // Replace null value internally to prevent weird slider behaviour with negative values
                if (this._nullValue) {
                    if (snaps[snaps.length - 1] == this._nullValue) {
                        this._internalNullValue = parseInt(snaps[snaps.length - 2]) + 100;
                        snaps.pop();
                        snaps.push(this._internalNullValue);
                    }
                }

                var value;

                // Set value
                if (this.getValue() === null || typeof this.getValue() === 'undefined') {
                    if (this._internalNullValue) {
                        value = this._internalNullValue;
                    } else {
                        value = snaps[0];
                    }
                } else {
                    if (this.getValue() == this._nullValue) {
                        value = this._internalNullValue;
                    } else {
                        value = this.getValue();
                    }
                }

                var distribution = _.map(snaps, function(value) {
                    return parseInt(value);
                });

                slider.xslider({
                    min: parseInt(snaps[0]),
                    max: parseInt(snaps[snaps.length - 1]),
                    value: parseInt(value),
                    snaps: snaps,
                    distribution: distribution,
                    slide: function(event, ui) {
                        if (ui.value == self._internalNullValue) {
                            self._updateLabel(self._nullValue);
                        } else {
                            self._updateLabel(ui.value);
                        }
                    },
                    stop: function(event, ui) {
                        if (ui.value == self._internalNullValue) {
                            self.setValue(self._nullValue);
                        } else {
                            self.setValue(ui.value);
                        }
                    },
                    create: function(event, ui) {
                        $('.ui-slider-handle', this).addClass(self.option('handleClass'));
                    }
                });

            },

            _processData: function(value) {
                if (value) {
                    return parseInt(value);
                }
            },

            _updateLabel: function(value) {
                if (this._label.length) {
                    var label = value;

                    if (value == this._nullValue) {
                        label = this._nullValueText;
                    } else {
                        if (this._valueTemplate) {
                            label = this._valueTemplate.replace('%d', label);
                        }
                        if (this._valuePostfix) {
                            label = label + '' + this._valuePostfix;
                        }
                    }

                    this._label.text(label);
                }
            },

            setValueToUi: function() {
                if (this.value === null) { return; }

                var slider = $(this.element).find('.slider');

                if (this.value != slider.xslider('xvalue')) {
                    if (this.value == this._nullValue) {
                        // Set internal null value to allow negative numbers
                        slider.xslider('xvalue', this._internalNullValue);
                    } else {
                        slider.xslider('xvalue', this.value);
                    }

                    this._updateLabel(this.value);
                }
            },
            getValueFromUi: function() {

            },
            _formatValue: function(value) {
                return value == this._anyValue ? this._anyValueText : ((value || this.value)) + ' ' + this._valuePostfix;
            }
        });

        return SliderFilterWidget;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/priceslider/priceSliderWidget.js